import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// `rounded-pill` and `shadow-soft(-lg)` are our own tokens (styles/theme.css).
// Without registering them, twMerge keeps both `rounded-md` and
// `rounded-pill` and the component's default wins over the override.
const twMerge = extendTailwindMerge({
  extend: { theme: { radius: ["pill"], shadow: ["soft", "soft-lg"] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
